import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type ListCardFragment = {
  __typename?: 'SearchableContent';
  id: string;
  latitude?: number | null;
  longitude?: number | null;
  distance?: number | null;
  result?:
    | {
        __typename?: 'Event';
        nextUpcomingInstanceDate?: any | null;
        freeSharryKind?: Types.FreeSharryKind | null;
        requiresPayment?: boolean | null;
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        nextEventInstance?: {
          __typename?: 'EventInstance';
          id: string;
          beginsAt?: any | null;
          endsAt?: any | null;
          hasDates?: boolean | null;
        } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
      }
    | {
        __typename?: 'FeaturedCard';
        createdAt?: any | null;
        expiringAt?: any | null;
        externalUrl?: string | null;
        id: string;
        latitude?: number | null;
        longitude?: number | null;
        shortAddress?: string | null;
        title?: string | null;
        updatedAt?: any | null;
        buttonText?: string | null;
        vendor?: string | null;
        region?: string | null;
        province?: string | null;
        municipality?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
      }
    | {
        __typename?: 'Sharry';
        soldBySharryland: boolean;
        description?: string | null;
        freeSharryKind?: Types.FreeSharryKind | null;
        requiresPayment?: boolean | null;
        isOnline?: boolean | null;
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        variantDuration?: {
          __typename?: 'VariantDuration';
          id: string;
          duration?: number | null;
          durationType?: Types.VariantDurationEnum | null;
        } | null;
        nextUpcomingVariant?: {
          __typename?: 'SharryVariant';
          id: string;
          price?: number | null;
          availability?: number | null;
          unlimitedAvailability?: boolean | null;
          custom?: boolean | null;
          default: boolean;
          discountedPrice?: number | null;
          definitions: Array<{
            __typename?: 'SharryVariantDefinition';
            id: string;
            definitionType?: string | null;
            definitionValue?: string | null;
            beginsAt?: any | null;
            endsAt?: any | null;
          }>;
          discount?: {
            __typename?: 'SharryDiscount';
            id: string;
            kind?: Types.SharryDiscountKind | null;
            percentage?: number | null;
            value?: number | null;
          } | null;
        } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
      }
    | {
        __typename?: 'User';
        id: string;
        distance?: number | null;
        name?: string | null;
        surname?: string | null;
        isSmallOrganisation?: boolean | null;
        anonymised?: boolean | null;
        businessName?: string | null;
        isProGold?: boolean | null;
        role: Types.UserRole;
        sharrylandPartner: boolean;
        workAddress?: string | null;
        whoIAm?: string | null;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        ambassador?: boolean | null;
        isPaladin?: boolean | null;
        friendlyMunicipality?: boolean | null;
        province?: string | null;
        municipality?: string | null;
        bookmarked?: boolean | null;
        image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
      }
    | null;
};

export type ListSearchQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SearchNode>;
  sort?: Types.InputMaybe<Types.SortFilter>;
  count?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  near?: Types.InputMaybe<Types.NearFilter>;
  titleFirst?: Types.InputMaybe<Types.Scalars['String']['input']>;
  withNoDates?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  noPastDatesEvents?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  nextDateOrder?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  reorder?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  soldBySharryland?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type ListSearchQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'SearchableContent';
    id: string;
    latitude?: number | null;
    longitude?: number | null;
    distance?: number | null;
    result?:
      | {
          __typename?: 'Event';
          nextUpcomingInstanceDate?: any | null;
          freeSharryKind?: Types.FreeSharryKind | null;
          requiresPayment?: boolean | null;
          id: string;
          distance?: number | null;
          contentType?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          shortAddress?: string | null;
          status: Types.SharryContentStatus;
          slug?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          province?: string | null;
          municipality?: string | null;
          title?: string | null;
          subtitle?: string | null;
          bookmarked?: boolean | null;
          nextEventInstance?: {
            __typename?: 'EventInstance';
            id: string;
            beginsAt?: any | null;
            endsAt?: any | null;
            hasDates?: boolean | null;
          } | null;
          coverPicture?: {
            __typename?: 'GalleryImage';
            id?: string | null;
            bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          sharryKind?: {
            __typename?: 'SharryKind';
            id: string;
            name?: string | null;
            nameIt?: string | null;
            nameEn?: string | null;
            contentType?: Types.SharryContentType | null;
          } | null;
          owner?: {
            __typename?: 'User';
            id: string;
            slug?: string | null;
            isProGold?: boolean | null;
            role: Types.UserRole;
            sharrylandPartner: boolean;
            stripePayoutsEnabled?: boolean | null;
            name?: string | null;
            surname?: string | null;
            businessName?: string | null;
            isSmallOrganisation?: boolean | null;
            image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
        }
      | {
          __typename?: 'FeaturedCard';
          createdAt?: any | null;
          expiringAt?: any | null;
          externalUrl?: string | null;
          id: string;
          latitude?: number | null;
          longitude?: number | null;
          shortAddress?: string | null;
          title?: string | null;
          updatedAt?: any | null;
          buttonText?: string | null;
          vendor?: string | null;
          region?: string | null;
          province?: string | null;
          municipality?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        }
      | {
          __typename?: 'Sharry';
          soldBySharryland: boolean;
          description?: string | null;
          freeSharryKind?: Types.FreeSharryKind | null;
          requiresPayment?: boolean | null;
          isOnline?: boolean | null;
          id: string;
          distance?: number | null;
          contentType?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          shortAddress?: string | null;
          status: Types.SharryContentStatus;
          slug?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          province?: string | null;
          municipality?: string | null;
          title?: string | null;
          subtitle?: string | null;
          bookmarked?: boolean | null;
          variantDuration?: {
            __typename?: 'VariantDuration';
            id: string;
            duration?: number | null;
            durationType?: Types.VariantDurationEnum | null;
          } | null;
          nextUpcomingVariant?: {
            __typename?: 'SharryVariant';
            id: string;
            price?: number | null;
            availability?: number | null;
            unlimitedAvailability?: boolean | null;
            custom?: boolean | null;
            default: boolean;
            discountedPrice?: number | null;
            definitions: Array<{
              __typename?: 'SharryVariantDefinition';
              id: string;
              definitionType?: string | null;
              definitionValue?: string | null;
              beginsAt?: any | null;
              endsAt?: any | null;
            }>;
            discount?: {
              __typename?: 'SharryDiscount';
              id: string;
              kind?: Types.SharryDiscountKind | null;
              percentage?: number | null;
              value?: number | null;
            } | null;
          } | null;
          coverPicture?: {
            __typename?: 'GalleryImage';
            id?: string | null;
            bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          sharryKind?: {
            __typename?: 'SharryKind';
            id: string;
            name?: string | null;
            nameIt?: string | null;
            nameEn?: string | null;
            contentType?: Types.SharryContentType | null;
          } | null;
          owner?: {
            __typename?: 'User';
            id: string;
            slug?: string | null;
            isProGold?: boolean | null;
            role: Types.UserRole;
            sharrylandPartner: boolean;
            stripePayoutsEnabled?: boolean | null;
            name?: string | null;
            surname?: string | null;
            businessName?: string | null;
            isSmallOrganisation?: boolean | null;
            image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
        }
      | {
          __typename?: 'User';
          id: string;
          distance?: number | null;
          name?: string | null;
          surname?: string | null;
          isSmallOrganisation?: boolean | null;
          anonymised?: boolean | null;
          businessName?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          workAddress?: string | null;
          whoIAm?: string | null;
          slug?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          ambassador?: boolean | null;
          isPaladin?: boolean | null;
          friendlyMunicipality?: boolean | null;
          province?: string | null;
          municipality?: string | null;
          bookmarked?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
          myFollow?: { __typename?: 'Follow'; id: string } | null;
          myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
        }
      | {
          __typename?: 'Wonder';
          id: string;
          distance?: number | null;
          contentType?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          shortAddress?: string | null;
          status: Types.SharryContentStatus;
          slug?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          province?: string | null;
          municipality?: string | null;
          title?: string | null;
          subtitle?: string | null;
          bookmarked?: boolean | null;
          coverPicture?: {
            __typename?: 'GalleryImage';
            id?: string | null;
            bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          sharryKind?: {
            __typename?: 'SharryKind';
            id: string;
            name?: string | null;
            nameIt?: string | null;
            nameEn?: string | null;
            contentType?: Types.SharryContentType | null;
          } | null;
          owner?: {
            __typename?: 'User';
            id: string;
            slug?: string | null;
            isProGold?: boolean | null;
            role: Types.UserRole;
            sharrylandPartner: boolean;
            stripePayoutsEnabled?: boolean | null;
            name?: string | null;
            surname?: string | null;
            businessName?: string | null;
            isSmallOrganisation?: boolean | null;
            image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
        }
      | null;
  }> | null;
};

export type MapCardFragment = {
  __typename?: 'SearchableContent';
  id: string;
  result?:
    | {
        __typename?: 'Event';
        id: string;
        slug?: string | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        latitude?: number | null;
        longitude?: number | null;
        distance?: number | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
    | {
        __typename?: 'FeaturedCard';
        createdAt?: any | null;
        expiringAt?: any | null;
        externalUrl?: string | null;
        id: string;
        latitude?: number | null;
        longitude?: number | null;
        shortAddress?: string | null;
        title?: string | null;
        updatedAt?: any | null;
        buttonText?: string | null;
        vendor?: string | null;
        region?: string | null;
        province?: string | null;
        municipality?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
      }
    | {
        __typename?: 'Sharry';
        id: string;
        slug?: string | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        latitude?: number | null;
        longitude?: number | null;
        distance?: number | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
    | {
        __typename?: 'User';
        id: string;
        isProGold?: boolean | null;
        role: Types.UserRole;
        sharrylandPartner: boolean;
        latitude?: number | null;
        longitude?: number | null;
        distance?: number | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        latitude?: number | null;
        longitude?: number | null;
        distance?: number | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
    | null;
};

export type MapSearchQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SearchNode>;
  sort?: Types.InputMaybe<Types.SortFilter>;
  count?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nearMap?: Types.InputMaybe<Types.NearFilter>;
  soldBySharryland?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type MapSearchQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'SearchableContent';
    id: string;
    result?:
      | {
          __typename?: 'Event';
          id: string;
          slug?: string | null;
          contentType?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          latitude?: number | null;
          longitude?: number | null;
          distance?: number | null;
          sharryKind?: {
            __typename?: 'SharryKind';
            id: string;
            name?: string | null;
            nameIt?: string | null;
            nameEn?: string | null;
            contentType?: Types.SharryContentType | null;
          } | null;
        }
      | {
          __typename?: 'FeaturedCard';
          createdAt?: any | null;
          expiringAt?: any | null;
          externalUrl?: string | null;
          id: string;
          latitude?: number | null;
          longitude?: number | null;
          shortAddress?: string | null;
          title?: string | null;
          updatedAt?: any | null;
          buttonText?: string | null;
          vendor?: string | null;
          region?: string | null;
          province?: string | null;
          municipality?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        }
      | {
          __typename?: 'Sharry';
          id: string;
          slug?: string | null;
          contentType?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          latitude?: number | null;
          longitude?: number | null;
          distance?: number | null;
          sharryKind?: {
            __typename?: 'SharryKind';
            id: string;
            name?: string | null;
            nameIt?: string | null;
            nameEn?: string | null;
            contentType?: Types.SharryContentType | null;
          } | null;
        }
      | {
          __typename?: 'User';
          id: string;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          latitude?: number | null;
          longitude?: number | null;
          distance?: number | null;
        }
      | {
          __typename?: 'Wonder';
          id: string;
          slug?: string | null;
          contentType?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          latitude?: number | null;
          longitude?: number | null;
          distance?: number | null;
          sharryKind?: {
            __typename?: 'SharryKind';
            id: string;
            name?: string | null;
            nameIt?: string | null;
            nameEn?: string | null;
            contentType?: Types.SharryContentType | null;
          } | null;
        }
      | null;
  }> | null;
};

export type GetMapUserQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetMapUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    distance?: number | null;
    name?: string | null;
    surname?: string | null;
    isSmallOrganisation?: boolean | null;
    anonymised?: boolean | null;
    businessName?: string | null;
    isProGold?: boolean | null;
    role: Types.UserRole;
    sharrylandPartner: boolean;
    workAddress?: string | null;
    whoIAm?: string | null;
    slug?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    ambassador?: boolean | null;
    isPaladin?: boolean | null;
    friendlyMunicipality?: boolean | null;
    province?: string | null;
    municipality?: string | null;
    bookmarked?: boolean | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
    myFollow?: { __typename?: 'Follow'; id: string } | null;
    myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
  } | null;
};

export type GetMapSharryContentQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetMapSharryContentQuery = {
  __typename?: 'Query';
  sharryContent?:
    | {
        __typename?: 'Event';
        nextUpcomingInstanceDate?: any | null;
        freeSharryKind?: Types.FreeSharryKind | null;
        requiresPayment?: boolean | null;
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        nextEventInstance?: {
          __typename?: 'EventInstance';
          id: string;
          beginsAt?: any | null;
          endsAt?: any | null;
          hasDates?: boolean | null;
        } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
      }
    | {
        __typename?: 'Post';
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
      }
    | {
        __typename?: 'Sharry';
        soldBySharryland: boolean;
        description?: string | null;
        freeSharryKind?: Types.FreeSharryKind | null;
        requiresPayment?: boolean | null;
        isOnline?: boolean | null;
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        variantDuration?: {
          __typename?: 'VariantDuration';
          id: string;
          duration?: number | null;
          durationType?: Types.VariantDurationEnum | null;
        } | null;
        nextUpcomingVariant?: {
          __typename?: 'SharryVariant';
          id: string;
          price?: number | null;
          availability?: number | null;
          unlimitedAvailability?: boolean | null;
          custom?: boolean | null;
          default: boolean;
          discountedPrice?: number | null;
          definitions: Array<{
            __typename?: 'SharryVariantDefinition';
            id: string;
            definitionType?: string | null;
            definitionValue?: string | null;
            beginsAt?: any | null;
            endsAt?: any | null;
          }>;
          discount?: {
            __typename?: 'SharryDiscount';
            id: string;
            kind?: Types.SharryDiscountKind | null;
            percentage?: number | null;
            value?: number | null;
          } | null;
        } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        contentLikes?: Array<{ __typename?: 'ContentLike'; id: string }> | null;
      }
    | null;
};

export type GetSearchCategoriesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SearchNode>;
  sort: Types.SortFilter;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetSearchCategoriesQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'Category';
    id?: string | null;
    name?: string | null;
    sort?: number | null;
    normalizedName?: string | null;
    icon?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    previewImage?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    searchBanners?: Array<{
      __typename?: 'SearchBanner';
      id: string;
      title?: string | null;
      text?: string | null;
      backgroundColor?: string | null;
      aiGenerated: boolean;
      visible?: boolean | null;
    }> | null;
  }> | null;
};

export type GetIndexCategoriesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetIndexCategoriesQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'Category';
    id?: string | null;
    name?: string | null;
    normalizedName?: string | null;
    icon?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    previewImage?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  }> | null;
};

export type GetCoordinatesByAddressQueryVariables = Types.Exact<{
  address: Types.Scalars['String']['input'];
}>;

export type GetCoordinatesByAddressQuery = {
  __typename?: 'Query';
  coordinatesByAddress?: {
    __typename?: 'CoordinatesFields';
    latitude?: number | null;
    longitude?: number | null;
  } | null;
};

export type AllPlaceUtilitiesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SearchNode>;
  sort?: Types.InputMaybe<Types.SortFilter>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type AllPlaceUtilitiesQuery = {
  __typename?: 'Query';
  allPlaceUtilities?: Array<{
    __typename?: 'PlaceUtility';
    id: string;
    distance?: number | null;
    family?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    name?: string | null;
    placeType?: string | null;
    place?: { __typename?: 'Place'; id: string } | null;
  }> | null;
};

export type FeaturedCardFragment = {
  __typename?: 'FeaturedCard';
  createdAt?: any | null;
  expiringAt?: any | null;
  externalUrl?: string | null;
  id: string;
  latitude?: number | null;
  longitude?: number | null;
  shortAddress?: string | null;
  title?: string | null;
  updatedAt?: any | null;
  buttonText?: string | null;
  vendor?: string | null;
  region?: string | null;
  province?: string | null;
  municipality?: string | null;
  sharrySelection?: Types.SharrySelection | null;
  image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
};

export type HashtagSearchQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SearchNode>;
  sort?: Types.InputMaybe<Types.SortFilter>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  communityTags?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type HashtagSearchQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'Hashtag';
    id: string;
    name: string;
    taggingsCount: number;
    taggingsCountCommunity?: number | null;
    trendingPlace?: string | null;
    zoom?: number | null;
  }> | null;
};

export type GetAccessibilityCategoriesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SearchNode>;
  sort: Types.SortFilter;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetAccessibilityCategoriesQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'AccessibilityCategory';
    id?: string | null;
    name?: string | null;
    sort?: number | null;
    icon?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  }> | null;
};

export type GetBannerByKeywordQueryVariables = Types.Exact<{
  keyword?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetBannerByKeywordQuery = {
  __typename?: 'Query';
  searchBanner?: {
    __typename?: 'SearchBanner';
    id: string;
    url?: Array<string> | null;
    keyword?: string | null;
    categoryId?: string | null;
    metaTag?: { __typename?: 'MetaTag'; id: string; title?: string | null; description?: string | null } | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    category?: { __typename?: 'Category'; id?: string | null; normalizedName?: string | null } | null;
  } | null;
};

export type GetSearchBannersQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetSearchBannersQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'SearchBanner';
    id: string;
    url?: Array<string> | null;
    keyword?: string | null;
    categoryId?: string | null;
    metaTag?: { __typename?: 'MetaTag'; id: string; title?: string | null; description?: string | null } | null;
    category?: { __typename?: 'Category'; id?: string | null; normalizedName?: string | null } | null;
  }> | null;
};

export type GetQualificationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SearchNode>;
  sort: Types.SortFilter;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetQualificationsQuery = {
  __typename?: 'Query';
  results?: Array<{
    __typename?: 'Qualification';
    id: string;
    text?: string | null;
    sort?: number | null;
    enabled?: boolean | null;
    requiresCertification?: boolean | null;
    usersCount?: number | null;
  }> | null;
};

export type CategoryByNormalizedNameQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;

export type CategoryByNormalizedNameQuery = {
  __typename?: 'Query';
  categoryByNormalizedName?: { __typename?: 'Category'; id?: string | null } | null;
};

export const FeaturedCardFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expiringAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'id' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonText' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ListCardFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchableContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardContent' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardUser' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'FeaturedCard' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expiringAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'id' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonText' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardContent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bestVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameEn' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shortAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtitle' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProGold' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrylandPartner' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stripePayoutsEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Sharry' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'soldBySharryland' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'freeSharryKind' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresPayment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isOnline' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'variantDuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'duration' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'durationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextUpcomingVariant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SharryVariant' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextUpcomingInstanceDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'freeSharryKind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiresPayment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextEventInstance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beginsAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasDates' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLikes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bookmarked' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SharryVariant' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryVariant' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'availability' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unlimitedAvailability' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'custom' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'default' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definitionType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'definitionValue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beginsAt' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'kind' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountedPrice' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardUser' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surname' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'anonymised' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '160x160', block: false },
                    },
                  ],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workAddress' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFollow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'whoIAm' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFavourite' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassador' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isPaladin' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'friendlyMunicipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'province' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'municipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookmarked' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MapCardFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MapCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchableContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameEn' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latitude' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'distance' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProGold' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrylandPartner' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longitude' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'FeaturedCard' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expiringAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'id' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonText' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ListSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'listSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchNode' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFilter' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'near' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NearFilter' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'titleFirst' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withNoDates' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'noPastDatesEvents' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nextDateOrder' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reorder' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'soldBySharryland' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'allSearchableContents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'near' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'near' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'titleFirst' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'titleFirst' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'withNoDates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'withNoDates' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'noPastDatesEvents' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'noPastDatesEvents' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nextDateOrder' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nextDateOrder' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reorder' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reorder' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'soldBySharryland' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'soldBySharryland' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListCard' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchableContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardContent' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardUser' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'FeaturedCard' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expiringAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'id' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonText' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardContent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bestVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameEn' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shortAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtitle' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProGold' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrylandPartner' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stripePayoutsEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Sharry' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'soldBySharryland' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'freeSharryKind' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresPayment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isOnline' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'variantDuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'duration' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'durationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextUpcomingVariant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SharryVariant' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextUpcomingInstanceDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'freeSharryKind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiresPayment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextEventInstance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beginsAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasDates' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLikes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bookmarked' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SharryVariant' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryVariant' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'availability' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unlimitedAvailability' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'custom' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'default' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definitionType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'definitionValue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beginsAt' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'kind' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountedPrice' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardUser' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surname' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'anonymised' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '160x160', block: false },
                    },
                  ],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workAddress' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFollow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'whoIAm' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFavourite' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassador' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isPaladin' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'friendlyMunicipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'province' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'municipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookmarked' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class ListSearchGQL extends Apollo.Query<ListSearchQuery, ListSearchQueryVariables> {
  document = ListSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const MapSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'mapSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchNode' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFilter' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nearMap' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NearFilter' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'soldBySharryland' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'allSearchableContents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nearMap' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nearMap' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'soldBySharryland' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'soldBySharryland' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MapCard' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MapCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchableContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameEn' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latitude' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'distance' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProGold' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrylandPartner' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longitude' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'FeaturedCard' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedCard' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FeaturedCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expiringAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'id' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonText' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'region' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class MapSearchGQL extends Apollo.Query<MapSearchQuery, MapSearchQueryVariables> {
  document = MapSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetMapUserDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMapUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardUser' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardUser' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surname' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'anonymised' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '160x160', block: false },
                    },
                  ],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workAddress' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFollow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'whoIAm' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFavourite' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassador' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isPaladin' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'friendlyMunicipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'province' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'municipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookmarked' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetMapUserGQL extends Apollo.Query<GetMapUserQuery, GetMapUserQueryVariables> {
  document = GetMapUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetMapSharryContentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMapSharryContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardContent' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardContent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bestVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameEn' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shortAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtitle' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProGold' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrylandPartner' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stripePayoutsEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Sharry' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'soldBySharryland' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'freeSharryKind' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresPayment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isOnline' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'variantDuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'duration' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'durationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextUpcomingVariant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SharryVariant' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextUpcomingInstanceDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'freeSharryKind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiresPayment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextEventInstance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beginsAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasDates' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLikes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bookmarked' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SharryVariant' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryVariant' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'availability' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unlimitedAvailability' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'custom' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'default' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definitionType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'definitionValue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beginsAt' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'kind' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountedPrice' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetMapSharryContentGQL extends Apollo.Query<GetMapSharryContentQuery, GetMapSharryContentQueryVariables> {
  document = GetMapSharryContentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetSearchCategoriesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSearchCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchNode' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFilter' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'allCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'normalizedName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'searchBanners' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'backgroundColor' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'visible' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetSearchCategoriesGQL extends Apollo.Query<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables> {
  document = GetSearchCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetIndexCategoriesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getIndexCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'allCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'normalizedName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetIndexCategoriesGQL extends Apollo.Query<GetIndexCategoriesQuery, GetIndexCategoriesQueryVariables> {
  document = GetIndexCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetCoordinatesByAddressDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCoordinatesByAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coordinatesByAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'address' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'longitude' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetCoordinatesByAddressGQL extends Apollo.Query<
  GetCoordinatesByAddressQuery,
  GetCoordinatesByAddressQueryVariables
> {
  document = GetCoordinatesByAddressDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const AllPlaceUtilitiesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allPlaceUtilities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchNode' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFilter' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPlaceUtilities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'distance' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'family' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latitude' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'placeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AllPlaceUtilitiesGQL extends Apollo.Query<AllPlaceUtilitiesQuery, AllPlaceUtilitiesQueryVariables> {
  document = AllPlaceUtilitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const HashtagSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'hashtagSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchNode' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFilter' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'communityTags' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'hashtagSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'communityTags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'communityTags' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'taggingsCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taggingsCountCommunity' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'trendingPlace' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'zoom' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class HashtagSearchGQL extends Apollo.Query<HashtagSearchQuery, HashtagSearchQueryVariables> {
  document = HashtagSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetAccessibilityCategoriesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAccessibilityCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchNode' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFilter' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'allAccessibilityCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '300x300', block: false },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetAccessibilityCategoriesGQL extends Apollo.Query<
  GetAccessibilityCategoriesQuery,
  GetAccessibilityCategoriesQueryVariables
> {
  document = GetAccessibilityCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetBannerByKeywordDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBannerByKeyword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keyword' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBanner' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'keyword' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'keyword' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'keyword' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metaTag' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'normalizedName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetBannerByKeywordGQL extends Apollo.Query<GetBannerByKeywordQuery, GetBannerByKeywordQueryVariables> {
  document = GetBannerByKeywordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetSearchBannersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSearchBanners' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'allSearchBanners' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'keyword' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metaTag' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'normalizedName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetSearchBannersGQL extends Apollo.Query<GetSearchBannersQuery, GetSearchBannersQueryVariables> {
  document = GetSearchBannersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetQualificationsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getQualifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchNode' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFilter' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'allQualifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresCertification' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usersCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetQualificationsGQL extends Apollo.Query<GetQualificationsQuery, GetQualificationsQueryVariables> {
  document = GetQualificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const CategoryByNormalizedNameDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'categoryByNormalizedName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryByNormalizedName' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'normalizedName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class CategoryByNormalizedNameGQL extends Apollo.Query<
  CategoryByNormalizedNameQuery,
  CategoryByNormalizedNameQueryVariables
> {
  document = CategoryByNormalizedNameDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
